import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	cover: {
		data: [],
		isLoaded: false,
		error: false
	},
	cover_large: {
		data: [],
		isLoaded: false,
		error: false
	},
	cover_small: {
		data: [],
		isLoaded: false,
		error: false
	},
	cover_detail: {
		data: [],
		isLoaded: false,
		error: false
	},
	cover_detail_large: {
		data: [],
		isLoaded: false,
		error: false
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** FETCH MAIN_ITEM COVER FILES ******************
			case types.FETCH_MAIN_ITEM_COVER_FILES_LOADING:
				draft.cover.data = [];
				draft.cover.isLoaded = false;
				draft.cover.error = false;
				return;

			case types.FETCH_MAIN_ITEM_COVER_FILES_SUCCESS:
				draft.cover.data = action.payload.map((file) => ({
					...file,
					uid: file.id
				}));
				draft.cover.isLoaded = true;
				return;

			case types.FETCH_MAIN_ITEM_COVER_FILES_ERROR:
				draft.cover.isLoaded = true;
				draft.cover.error = true;
				return;

			// ****************** FETCH MAIN_ITEM COVER_LARGE FILES ******************
			case types.FETCH_MAIN_ITEM_COVER_LARGE_FILES_LOADING:
				draft.cover_large.data = [];
				draft.cover_large.isLoaded = false;
				draft.cover_large.error = false;
				return;

			case types.FETCH_MAIN_ITEM_COVER_LARGE_FILES_SUCCESS:
				draft.cover_large.data = action.payload.map((file) => ({
					...file,
					uid: file.id
				}));
				draft.cover_large.isLoaded = true;
				return;

			case types.FETCH_MAIN_ITEM_COVER_LARGE_FILES_ERROR:
				draft.cover_large.isLoaded = true;
				draft.cover_large.error = true;
				return;

			// ****************** FETCH MAIN_ITEM COVER_SMALL FILES ******************
			case types.FETCH_MAIN_ITEM_COVER_SMALL_FILES_LOADING:
				draft.cover_small.data = [];
				draft.cover_small.isLoaded = false;
				draft.cover_small.error = false;
				return;

			case types.FETCH_MAIN_ITEM_COVER_SMALL_FILES_SUCCESS:
				draft.cover_small.data = action.payload.map((file) => ({
					...file,
					uid: file.id
				}));
				draft.cover_small.isLoaded = true;
				return;

			case types.FETCH_MAIN_ITEM_COVER_SMALL_FILES_ERROR:
				draft.cover_small.isLoaded = true;
				draft.cover_small.error = true;
				return;

			// ****************** FETCH MAIN_ITEM COVER_DETAIL FILES ******************
			case types.FETCH_MAIN_ITEM_COVER_DETAIL_FILES_LOADING:
				draft.cover_detail.data = [];
				draft.cover_detail.isLoaded = false;
				draft.cover_detail.error = false;
				return;

			case types.FETCH_MAIN_ITEM_COVER_DETAIL_FILES_SUCCESS:
				draft.cover_detail.data = action.payload.map((file) => ({
					...file,
					uid: file.id
				}));
				draft.cover_detail.isLoaded = true;
				return;

			case types.FETCH_MAIN_ITEM_COVER_DETAIL_FILES_ERROR:
				draft.cover_detail.isLoaded = true;
				draft.cover_detail.error = true;
				return;

			// ****************** FETCH MAIN_ITEM COVER_DETAIL_LARGE FILES ******************
			case types.FETCH_MAIN_ITEM_COVER_DETAIL_LARGE_FILES_LOADING:
				draft.cover_detail_large.data = [];
				draft.cover_detail_large.isLoaded = false;
				draft.cover_detail_large.error = false;
				return;

			case types.FETCH_MAIN_ITEM_COVER_DETAIL_LARGE_FILES_SUCCESS:
				draft.cover_detail_large.data = action.payload.map((file) => ({
					...file,
					uid: file.id
				}));
				draft.cover_detail_large.isLoaded = true;
				return;

			case types.FETCH_MAIN_ITEM_COVER_DETAIL_LARGE_FILES_ERROR:
				draft.cover_detail_large.isLoaded = true;
				draft.cover_detail_large.error = true;
				return;

			default:
				return state;
		}
	});
